// extracted by mini-css-extract-plugin
export default {"img":"ModalIngredientsDetails_img__zKOzM","div":"ModalIngredientsDetails_div__4nNje","ul":"ModalIngredientsDetails_ul__49dsf","li":"ModalIngredientsDetails_li__XDSYu"};